import { Avatar, Dropdown, Menu, Typography, Tooltip } from 'antd';
import {
  CaretDownOutlined,
  LogoutOutlined
  //ToolOutlined
} from '@ant-design/icons';
import styles from './index.module.less';
import { logout } from 'features/login/redux/slice';
import { useDispatch } from 'react-redux';
import { useMsal } from '@azure/msal-react';
//import { Link } from 'react-router-dom';
import LocalStorage from 'utilities/localStorage';

const { Text } = Typography;

const UserMenu = () => {
  const { instance } = useMsal();
  const dispatch = useDispatch();
  const userDetails = LocalStorage.getItem('GiftReg_user');
  //console.log('userDetails', userDetails);
  const userFullName = userDetails?.user?.name ? (
    <span>{userDetails.user?.name.slice(0, 1)}</span>
  ) : (
    'U'
  );

  const signOutClickHandler = async () => {
    try {
      // Clear active account first
      instance.setActiveAccount(null);

      // Get all accounts and logout each one
      const accounts = instance.getAllAccounts();

      // Dispatch logout to clear localStorage (including MSAL keys)
      dispatch(logout());

      // Perform logout redirect - this will clear MSAL session on Microsoft side
      if (accounts.length > 0) {
        instance.logoutRedirect({
          account: accounts[0], // Use first account or LocalStorage.homeAccountId
          postLogoutRedirectUri: window.location.origin + '/',
          mainWindowRedirectUri: window.location.origin + '/',
          onRedirectNavigate: (url) => {
            console.log('url', url);
            return true;
          }
        });
      } else {
        // If no accounts, just redirect to home
        window.location.href = '/';
      }
    } catch (error) {
      console.error('Logout error:', error);
      // Fallback: clear everything and redirect
      dispatch(logout());
      instance.setActiveAccount(null);
      window.location.href = '/';
    }
  };
  const menu = (
    <Menu>
      <Menu.Item
        onClick={() => signOutClickHandler()}
        key="1"
        icon={<LogoutOutlined />}
      >
        <Text>Logout</Text>
      </Menu.Item>

      {/* <Menu>
      <Menu.Item key="1" icon={<LogoutOutlined />}>
        <Text onClick={() => dispatch(logout())}>Logout</Text>
      </Menu.Item>
      <Menu.Item key="2" icon={<ToolOutlined />}>
        <Link to="/changepassword">Change Password</Link>
      </Menu.Item>
    </Menu> */}
    </Menu>
  );

  return (
    <Dropdown overlay={menu}>
      <div className={`df-jb-ac ${styles.user_menu_container}`}>
        <Tooltip
          title={
            <span>
              {userDetails.user?.name}
              <div>Role: {userDetails.user?.roles[0]}</div>
            </span>
          }
          placement="left"
          color={'white'}
          overlayInnerStyle={{
            color: '#32324D',
            fontSize: '12px',
            fontFamily: 'SFProText Regular'
          }}
        >
          <Avatar className={styles.user_menu_avatar}>{userFullName}</Avatar>
        </Tooltip>
        <CaretDownOutlined />
      </div>
    </Dropdown>
  );
};

export default UserMenu;
